import React from 'react'
import Rate from '../components/Rate'
import LiveBoard from '../components/LiveBoard'
import Activities from '../components/Activities'
import Slideshow from '../components/Slideshow'

const Home = () => {
  return (
    <>
    {/* Rate section */}
    <Rate />

      <div className="flex w-full md:h-[60%] md:gap-2 items-center">
          {/* Slider section */}
          <div className="h-full max-md:h-fit w-full md:w-[70%] min-h-[240px] flex md:border rounded-[24px] items-center justify-center overflow-hidden">
            <Slideshow />
          </div>
          <div className="h-full max-md:hidden w-[30%] overflow-hidden min-h-[240px] max-md:h-[50%] rounded-[24px] bg-slate-100">
            {/* Live board section */}
            <LiveBoard />
          </div>
        </div>
        {/* Activities section */}
        <Activities />

        <div className="md:hidden">
          {/* Live board section */}
          <LiveBoard />
        </div>
    </>
  )
}

export default Home
